import React from "react";
import Advocacy from "../../components/Advocacy/Advocacy";

const AdvocacyPage = () => {
  return <Advocacy />;
};

export default AdvocacyPage;
